// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: "Open Sans", sans-serif;
}

.cookie-consent {
  position: fixed;
  inset: 0;
  z-index: 11000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  pointer-events: none;
  background-color: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  padding: 16px;
  animation: cookie-consent-overlay-fade 0.25s ease-out;
}

.cookie-consent__panel {
  pointer-events: auto;
  width: 100%;
  max-width: 920px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  background: var(--fc-bg, #ffffff);
  color: var(--fc-fg, #212529);
  border: 1px solid var(--fc-border, #e0e0e0);
  border-radius: 10px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  padding: 24px 28px;
  margin-bottom: 16px;
  animation: cookie-consent-panel-slide 0.3s ease-out;
}
.cookie-consent__panel::-webkit-scrollbar {
  width: 8px;
}
.cookie-consent__panel::-webkit-scrollbar-track {
  background: var(--fc-bg2, #f1f1f1);
  border-radius: 10px;
}
.cookie-consent__panel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
.cookie-consent__panel::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.cookie-consent__header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.cookie-consent__icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #5ea1d8;
  flex-shrink: 0;
  margin-top: 2px;
}

.cookie-consent__heading {
  flex: 1;
  min-width: 0;
}

.cookie-consent__title {
  margin: 0 0 6px !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  line-height: 1.3 !important;
  color: var(--fc-fg, #212529) !important;
  font-family: "Open Sans", sans-serif !important;
}

.cookie-consent__description {
  margin: 0 !important;
  font-size: 14px !important;
  line-height: 1.55 !important;
  font-weight: 500 !important;
  color: var(--fc-fg-muted, #6c757d) !important;
  font-family: "Open Sans", sans-serif !important;
}
.cookie-consent__description a {
  color: #5ea1d8 !important;
  text-decoration: underline;
  font-weight: 600;
}
.cookie-consent__description a:hover {
  color: #4d8fc4 !important;
}

.cookie-consent__actions {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.cookie-consent__btn {
  -webkit-appearance: none;
          appearance: none;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.05s ease, color 0.18s ease, border-color 0.18s ease;
  min-width: 130px;
}
.cookie-consent__btn:active {
  transform: translateY(1px);
}
.cookie-consent__btn:focus-visible {
  outline: 2px solid #5ea1d8;
  outline-offset: 2px;
}

.cookie-consent__btn--primary {
  background: #5ea1d8;
  color: #ffffff;
}
.cookie-consent__btn--primary:hover {
  background: #4d8fc4;
  box-shadow: 0 6px 14px rgba(94, 161, 216, 0.35);
}

.cookie-consent__btn--secondary {
  background: var(--fc-bg, #ffffff);
  color: var(--fc-fg, #212529);
  border: 1px solid var(--fc-border, #e0e0e0);
}
.cookie-consent__btn--secondary:hover {
  background: var(--fc-bg-hover, #f5f7fa);
  border-color: #5ea1d8;
  color: #5ea1d8;
}

:host-context(body.theme-dark) .cookie-consent {
  background-color: rgba(0, 0, 0, 0.55);
}
:host-context(body.theme-dark) .cookie-consent__panel {
  background: #111921;
  color: #e5e7eb;
  border-color: rgba(148, 163, 184, 0.2);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.6);
}
:host-context(body.theme-dark) .cookie-consent__title {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .cookie-consent__description {
  color: #cbd5f5 !important;
}
:host-context(body.theme-dark) .cookie-consent__description a {
  color: #7fb8e6 !important;
}
:host-context(body.theme-dark) .cookie-consent__description a:hover {
  color: #a8d0ed !important;
}
:host-context(body.theme-dark) .cookie-consent__btn--secondary {
  background: rgba(255, 255, 255, 0.06);
  color: #e5e7eb;
  border-color: rgba(148, 163, 184, 0.25);
}
:host-context(body.theme-dark) .cookie-consent__btn--secondary:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: #5ea1d8;
  color: #7fb8e6;
}

@media (max-width: 640px) {
  .cookie-consent {
    padding: 0;
    align-items: flex-end;
  }
  .cookie-consent__panel {
    margin-bottom: 0;
    padding: 20px 18px 18px;
    border-radius: 14px 14px 0 0;
    max-height: 92vh;
    border-bottom: none;
  }
  .cookie-consent__header {
    gap: 12px;
  }
  .cookie-consent__icon {
    font-size: 24px;
    width: 24px;
    height: 24px;
  }
  .cookie-consent__title {
    font-size: 16px !important;
  }
  .cookie-consent__description {
    font-size: 13px !important;
  }
  .cookie-consent__actions {
    justify-content: stretch;
  }
  .cookie-consent__btn {
    flex: 1 1 calc(50% - 5px);
    min-width: 0;
    padding: 10px 12px;
  }
}
@keyframes cookie-consent-overlay-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes cookie-consent-panel-slide {
  from {
    transform: translateY(24px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/cookie-consent/cookie-consent.component.scss"],"names":[],"mappings":"AAIA;EACE,oCAAA;AAHF;;AAMA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,wCAAA;EACA,0BAAA;EACA,kCAAA;EACA,aAAA;EACA,qDAAA;AAHF;;AAMA;EACE,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iCAAA;EACA,4BAAA;EACA,2CAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,mBAAA;EACA,mDAAA;AAHF;AAME;EACE,UAAA;AAJJ;AAME;EACE,kCAAA;EACA,mBAAA;AAJJ;AAME;EACE,gBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,gBAAA;AAJN;;AASA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AANF;;AASA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AANF;;AASA;EACE,OAAA;EACA,YAAA;AANF;;AAaA;EACE,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,uCAAA;EACA,+CAAA;AAVF;;AAaA;EACE,oBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,6CAAA;EACA,+CAAA;AAVF;AAYE;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;;AAeA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;AAZF;;AAeA;EACE,wBAAA;UAAA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,+HAAA;EAEA,gBAAA;AAbF;AAeE;EACE,0BAAA;AAbJ;AAgBE;EACE,0BAAA;EACA,mBAAA;AAdJ;;AAmBA;EACE,mBAAA;EACA,cAAA;AAhBF;AAkBE;EACE,mBAAA;EACA,+CAAA;AAhBJ;;AAqBA;EACE,iCAAA;EACA,4BAAA;EACA,2CAAA;AAlBF;AAoBE;EACE,uCAAA;EACA,qBAAA;EACA,cAAA;AAlBJ;;AAyBE;EACE,qCAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,cAAA;EACA,sCAAA;EACA,4CAAA;AAvBJ;AA0BE;EACE,yBAAA;AAxBJ;AA2BE;EACE,yBAAA;AAzBJ;AA2BI;EACE,yBAAA;AAzBN;AA2BM;EACE,yBAAA;AAzBR;AA8BE;EACE,qCAAA;EACA,cAAA;EACA,uCAAA;AA5BJ;AA8BI;EACE,qCAAA;EACA,qBAAA;EACA,cAAA;AA5BN;;AAkCA;EACE;IACE,UAAA;IACA,qBAAA;EA/BF;EAkCA;IACE,gBAAA;IACA,uBAAA;IACA,4BAAA;IACA,gBAAA;IACA,mBAAA;EAhCF;EAmCA;IACE,SAAA;EAjCF;EAoCA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAlCF;EAqCA;IACE,0BAAA;EAnCF;EAsCA;IACE,0BAAA;EApCF;EAuCA;IACE,wBAAA;EArCF;EAwCA;IACE,yBAAA;IACA,YAAA;IACA,kBAAA;EAtCF;AACF;AA0CA;EACE;IACE,UAAA;EAxCF;EA0CA;IACE,UAAA;EAxCF;AACF;AA2CA;EACE;IACE,2BAAA;IACA,UAAA;EAzCF;EA2CA;IACE,wBAAA;IACA,UAAA;EAzCF;AACF","sourcesContent":["// Cookie Consent Banner\n// Uses the global Flowchest design tokens (--fc-bg, --fc-fg, etc.) so it\n// automatically responds to body.theme-dark like the rest of the site.\n\n:host {\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.cookie-consent {\n  position: fixed;\n  inset: 0;\n  z-index: 11000;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  pointer-events: none;\n  background-color: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  padding: 16px;\n  animation: cookie-consent-overlay-fade 0.25s ease-out;\n}\n\n.cookie-consent__panel {\n  pointer-events: auto;\n  width: 100%;\n  max-width: 920px;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  background: var(--fc-bg, #ffffff);\n  color: var(--fc-fg, #212529);\n  border: 1px solid var(--fc-border, #e0e0e0);\n  border-radius: 10px;\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  padding: 24px 28px;\n  margin-bottom: 16px;\n  animation: cookie-consent-panel-slide 0.3s ease-out;\n\n  // Hide scrollbar but keep functionality (matches .auth-modal-container)\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: var(--fc-bg2, #f1f1f1);\n    border-radius: 10px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 10px;\n\n    &:hover {\n      background: #555;\n    }\n  }\n}\n\n.cookie-consent__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.cookie-consent__icon {\n  font-size: 28px;\n  width: 28px;\n  height: 28px;\n  color: #5ea1d8;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.cookie-consent__heading {\n  flex: 1;\n  min-width: 0;\n}\n\n// !important is used here because the global styles.scss sets\n// `h2 { color: #212427 !important; font-size: 2rem !important; }` and\n// `p { color: #212427 !important; font-size: 14px !important; ... }` which\n// would otherwise make our heading/text dark on the dark panel.\n.cookie-consent__title {\n  margin: 0 0 6px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  line-height: 1.3 !important;\n  color: var(--fc-fg, #212529) !important;\n  font-family: \"Open Sans\", sans-serif !important;\n}\n\n.cookie-consent__description {\n  margin: 0 !important;\n  font-size: 14px !important;\n  line-height: 1.55 !important;\n  font-weight: 500 !important;\n  color: var(--fc-fg-muted, #6c757d) !important;\n  font-family: \"Open Sans\", sans-serif !important;\n\n  a {\n    color: #5ea1d8 !important;\n    text-decoration: underline;\n    font-weight: 600;\n\n    &:hover {\n      color: #4d8fc4 !important;\n    }\n  }\n}\n\n.cookie-consent__actions {\n  margin-top: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.cookie-consent__btn {\n  appearance: none;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  transition: background-color 0.18s ease, box-shadow 0.18s ease,\n    transform 0.05s ease, color 0.18s ease, border-color 0.18s ease;\n  min-width: 130px;\n\n  &:active {\n    transform: translateY(1px);\n  }\n\n  &:focus-visible {\n    outline: 2px solid #5ea1d8;\n    outline-offset: 2px;\n  }\n}\n\n// Primary action — Flowchest brand colour\n.cookie-consent__btn--primary {\n  background: #5ea1d8;\n  color: #ffffff;\n\n  &:hover {\n    background: #4d8fc4;\n    box-shadow: 0 6px 14px rgba(94, 161, 216, 0.35);\n  }\n}\n\n// Secondary outlined action\n.cookie-consent__btn--secondary {\n  background: var(--fc-bg, #ffffff);\n  color: var(--fc-fg, #212529);\n  border: 1px solid var(--fc-border, #e0e0e0);\n\n  &:hover {\n    background: var(--fc-bg-hover, #f5f7fa);\n    border-color: #5ea1d8;\n    color: #5ea1d8;\n  }\n}\n\n// ── Dark-mode overrides (mirrors the legal-center-layout pattern) ─────────\n// Uses !important to win against the global p/h2 colour rules in styles.scss.\n:host-context(body.theme-dark) {\n  .cookie-consent {\n    background-color: rgba(0, 0, 0, 0.55);\n  }\n\n  .cookie-consent__panel {\n    background: #111921;\n    color: #e5e7eb;\n    border-color: rgba(148, 163, 184, 0.2);\n    box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.6);\n  }\n\n  .cookie-consent__title {\n    color: #f8fafc !important;\n  }\n\n  .cookie-consent__description {\n    color: #cbd5f5 !important;\n\n    a {\n      color: #7fb8e6 !important;\n\n      &:hover {\n        color: #a8d0ed !important;\n      }\n    }\n  }\n\n  .cookie-consent__btn--secondary {\n    background: rgba(255, 255, 255, 0.06);\n    color: #e5e7eb;\n    border-color: rgba(148, 163, 184, 0.25);\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.12);\n      border-color: #5ea1d8;\n      color: #7fb8e6;\n    }\n  }\n}\n\n// ── Responsive: bottom-sheet style on mobile ──────────────────────────────\n@media (max-width: 640px) {\n  .cookie-consent {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .cookie-consent__panel {\n    margin-bottom: 0;\n    padding: 20px 18px 18px;\n    border-radius: 14px 14px 0 0;\n    max-height: 92vh;\n    border-bottom: none;\n  }\n\n  .cookie-consent__header {\n    gap: 12px;\n  }\n\n  .cookie-consent__icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n\n  .cookie-consent__title {\n    font-size: 16px !important;\n  }\n\n  .cookie-consent__description {\n    font-size: 13px !important;\n  }\n\n  .cookie-consent__actions {\n    justify-content: stretch;\n  }\n\n  .cookie-consent__btn {\n    flex: 1 1 calc(50% - 5px);\n    min-width: 0;\n    padding: 10px 12px;\n  }\n}\n\n// ── Animations ────────────────────────────────────────────────────────────\n@keyframes cookie-consent-overlay-fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes cookie-consent-panel-slide {\n  from {\n    transform: translateY(24px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
